import Dashboard from "./components/Dashboard";
import Login from "./components/Login";
import "./styles/global.css";

export default function App() {
  return <Dashboard />;
}